import React, {useEffect, useState} from "react";
import {PanelStack} from "../panel-stack/PanelStack";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {IJobStepRun} from "../../models/JobStepRun";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {GET_JOB_STEP_RUNS} from "../graphql/queries/gqlGetJobStepRuns";
import {Alert, Badge, Breadcrumbs, Button, CircularProgress, Link, Typography} from "@mui/material";
import {JobStepRun} from "./JobStepRun";
import {ICustomTabWindow} from "../interfaces/ICustomTabWindow";
import {
	createQueryParameterString,
	getQueryParameter,
} from "../../../../libraries/util/QueryParameterHelper";
import {IJobRun} from "../../models/JobRun";
import {IJobDefinitionStep} from "../../models/JobDefinitionStep";
import {PendingActions} from "@mui/icons-material";
import {ConfirmationDialog} from "../../../../components/common/confirmation-dialog/ConfirmationDialog";
import {PentaSplit} from "../../../../components/common/PentaSplit";
import {toast} from "react-toastify";
import {RUN_JOB_STEP} from "../graphql/mutations/gqlRunJobStep";
import {useNavigate} from "react-router-dom";
import {FilesCard} from "../job/Files";
import {GenericModal} from "../generic-modal/GenericModal";

export const JobStepRuns: React.FC = (_) => {
	const [data, setData] = useState<IJobRun>();
	const [submitLoading, setSubmitLoading] = useState<boolean>(false);
	const [manageFiles, setManageFiles] = useState<boolean>(false);
	const jobRunId: number = +(getQueryParameter("jobRunId") ?? "0");
	const jobId: number = +(getQueryParameter("jobId") ?? "0");
	const jobDefinitionId: number = +(
		getQueryParameter("jobDefinitionId") ?? "0"
	);

	const getIcon = (step: Partial<IJobDefinitionStep>, stepRun?: IJobStepRun) => {
		return <></>;
	};
	
	const runJobStep = (stepId: number | undefined) => {
		setSubmitLoading(true);
		
		graphQLServices.querytoolClient
			.mutate({
				mutation: RUN_JOB_STEP,
				variables: {
					jobRunId: jobRunId,
					stepId: stepId,
				},
			})
			
			.then((result) => {
				const id = result.data.runJobStep?.jobStepRun?.id;
				if (id) {
					fetch();
					toast.success("Step started");
				} else {
					toast.error(
						result.data.runJobStep?.errors[0]?.message ?? "Failed"
					);
				}
			})
			.catch(reason => {
				toast.error(reason);
			})
			.finally(() => setSubmitLoading(false));
	};
	
	const tabs: ICustomTabWindow[] =
		data?.job.jobDefinition.jobSteps.sort((a,b) => a.order < b.order? -1: 1).map((jobStep, index) => {
			const jobStepRun = data.jobStepRuns.find(
				(x) => x.jobStep?.id === jobStep.id
			);
			const prevStep = index > 0 ? data?.jobStepRuns[index - 1] : null;
			const stepId = jobStep.id;
			return {
				icon: getIcon(jobStep, jobStepRun),
				title: (
					<PentaSplit
						top={<div>{jobStep.description ?? ""}</div>}
						center={
							<>
								<br/>
								{!jobStepRun && <PendingActions/>}
								{jobStepRun && jobStepRun.succeeded > 0 && (
									<>
										<Badge
											color="success"
											badgeContent={jobStepRun.succeeded}
											max={1000000}
										>
											<CheckCircleOutlineIcon/>
										</Badge>
									</>
								)}
								&nbsp;
								{jobStepRun && jobStepRun.failed > 0 && (
									<Badge
										color="error"
										badgeContent={jobStepRun.failed}
										max={1000000}
									>
										<ErrorOutlineIcon/>
									</Badge>
								)}
							</>
						}
					/>
				),
				window: (
					<>
						{jobStepRun && (
							<JobStepRun
								jobRunId={jobRunId}
								jobStepRunId={jobStepRun.id}
								key={`job_definitions-jobs-job_runs-job_step_runs-job_step_run-${index}`}
							/>
						)}
						{data?.start && !jobStepRun && (index === 0 || (prevStep && prevStep.finish)) && (
							<ConfirmationDialog
								onSuccess={() => runJobStep(stepId)}
								dialogTitle={"Are you sure?"}
								buttonTitle={"Start this step"}
								buttonProps={{ variant: "outlined" }}
								dialogDescription={"This will start this step "}
							/>
						)}
						{!data?.start && (
							<Alert severity={"info"}>Waiting for start</Alert>
						)}
					</>
				),
				actions: [{title: "New Run From This Run", action: () => navigate("/querytool/jobs/runs/newrunfromrun" + createQueryParameterString({jobRunId: data?.id}))}]
			};
		}) ?? [];
	
	const navigate = useNavigate();

	const fetch = async () => {
		setSubmitLoading(true);
		const result = await graphQLServices.querytoolClient.query({
			query: GET_JOB_STEP_RUNS,
			variables: {
				jobRunId: jobRunId,
			},
		});

		setData(result?.data?.jobRun?.nodes.firstOrNull() ?? []);
		setSubmitLoading(false);
	};

	useEffect(() => {
		fetch();
		// eslint-disable-next-line
	}, []);

	
	return (
		<>
			{/*<>*/}
			{/*	<ConfirmationDialog*/}
			{/*		onSuccess={() => navigate("/querytool/jobs/runs/newrunfromrun" + createQueryParameterString({*/}
			{/*			jobRunId: data?.id,*/}
			{/*		}))}*/}
			{/*		dialogTitle={"Are you sure?"}*/}
			{/*		buttonTitle={"New Run From This Run"}*/}
			{/*		buttonProps={{ variant: "outlined" }}*/}
			{/*		successTitle={"Next"}*/}
			{/*		dialogDescription={*/}
			{/*			"This will restart this run with a new GraphQlQuery. Input for found records will be taken from this run."*/}
			{/*		}*/}
			{/*	/>*/}
			{/*</>,*/}
			<PentaSplit
				center={
					<>
						{submitLoading && <CircularProgress/>}
						{!submitLoading &&
							<div>
								<Breadcrumbs aria-label="breadcrumb">
									<Link underline="hover" color="inherit" href="/querytool/jobdefinitions">
										QueryTool
									</Link>
									<Link underline="hover" color="inherit" href="/querytool/jobdefinitions">
										Job Definitions
									</Link>
									<Link
										underline="hover"
										color="inherit"
										href={`/querytool/jobs${createQueryParameterString({
											jobDefinitionId,
										})}`}
									>
										Jobs
									</Link>
									<Link
										underline="hover"
										color="inherit"
										href={`/querytool/jobs/runs${createQueryParameterString({
											jobDefinitionId,
											jobId,
										})}`}
									>
										Job Runs
									</Link>
									<Typography color="text.primary">Job Step Runs</Typography>
								</Breadcrumbs>
								<Typography variant="h3" component="h2">
									{data?.job.description}:{data?.id}
								</Typography>
								<Button variant="outlined" onClick={() => setManageFiles(true)}>View Files</Button>
								<PanelStack tabs={tabs} />
								<GenericModal open={manageFiles} onClose={() => setManageFiles(false)} title={"Files"}>
									<FilesCard id={jobRunId} type={"JOB_RUN"} allowUpload={false}/>
								</GenericModal>
							</div>
						}
					</>
				}
			/>
		</>
	);
};
